export default "__VITE_ASSET__78f0800e__"